import { render, staticRenderFns } from "./CompanyNewsPage.vue?vue&type=template&id=104127fc"
import script from "./CompanyNewsPage.vue?vue&type=script&lang=js"
export * from "./CompanyNewsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports